import { render } from "./PickMpio.vue?vue&type=template&id=330a4e60"
import script from "./PickMpio.vue?vue&type=script&lang=ts"
export * from "./PickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script